import styled from 'styled-components';
import { beam } from '@styles/colors/themes';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';

export const Search = styled.input`
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.161);
  border: none;
  border-radius: 8px;
  font-size: 14px;
  color: #787878;
  height: 36px;
  display: flex;
  align-items: center;
  flex: 1;
  padding-left: 31px;
  padding-right: 8px;
  -webkit-appearance: none;
  z-index: 999;

  cursor: auto;
  /* borders/light-border */

  ::placeholder {
    color: #787878;
  }
`;
export const SearchImg = styled.img`
  position: absolute;
  left: 12px;
  z-index: 999;
  color: ${beam.font.label};
`;
export const BodySelect = styled.div`
  /* Layout Properties */
  width: 100%;
  margin-top: 50px;
  height: 100%;
  display: flex;
  align-items: start;
  align-content: flex-start;
  flex-direction: column;
  justify-content: start;
  justify-items: start;
`;
export const ButtonRow = styled.div`
  display: flex;
  flex-direction: row;
  align-content: center;
  align-items: center;
  justify-items: center;
  justify-content: center;
`;
export const BottomButton = styled.button`
  :disabled {
    cursor: default;
    opacity: 0.3;
  }
  border: none;
  box-shadow: 0 1px 4px rgba(19, 113, 254, 0.7);
  border-radius: 8px;
  padding: 8px 16px;
  display: flex;
  align-items: center;
  font-size: 14px;
  margin-left: 16px;
  cursor: pointer;
  background: ${beam.color.primaryBlue};
  color: ${beam.color.pureWhite};
`;
export const Bottom = styled.div`
  display: flex;
  margin-top: 16px;
  margin-bottom: 24px;
  align-items: center;
  align-content: center;
  justify-content: space-between;
`;
export const SearchContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  flex: 1;
  width: 430px;
  margin-bottom: 16px;
`;
export const WhiteBottomButton = styled(BottomButton)`
  background: transparent;
  border: 1px solid ${beam.border.back};
  color: ${beam.font.primary};
  box-shadow: none;
`;

export const CheckCircle = styled(CheckCircleIcon)`
  color: ${beam.color.primaryBlue};
  &.MuiSvgIcon-colorDisabled {
    color: #8f95b2;
  }
`;
export const UncheckCircle = styled(RadioButtonUncheckedIcon)`
  color: #d0dae3;
`;
